/**
 * MobileMenu.js
 */

import $ from 'jquery';
import Utilities from './Utilities';
import { TweenLite } from 'gsap';

const $mobileMenuSlide = $('.menu-dd');
    

class MobileMenu {

    constructor() {


        $('.menu-wrapper').on('click', function () {
            $('header').toggleClass('animate');
            if ( $('header').hasClass('animate') ) {
                TweenLite.to($mobileMenuSlide, .3, { ease: Circ.easeInOut, bottom: $mobileMenuSlide.height() * (-1) });
            } else {
                TweenLite.to($mobileMenuSlide, .3, { ease: Circ.easeInOut, bottom: '100%' });
            }
        })

    }

}
new MobileMenu();